module.exports = __webpack_public_path__ + "img/cases-brand-avic-lazyload-1324.2c1f4502.jpg";